"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TherapistLanding = void 0;
const react_1 = __importStar(require("react"));
const TherapistLanding_elements_1 = require("./TherapistLanding.elements");
const two_people_svg_1 = __importDefault(require("@components/icons/landing/two-people.svg"));
const play_button_svg_1 = __importDefault(require("@components/icons/landing/play-button.svg"));
const notesboard_svg_1 = __importDefault(require("@components/icons/landing/notesboard.svg"));
const rate_svg_1 = __importDefault(require("@components/icons/landing/rate.svg"));
const handlers_svg_1 = __importDefault(require("@components/icons/landing/handlers.svg"));
const video_and_pic_svg_1 = __importDefault(require("@components/icons/landing/video-and-pic.svg"));
const oralo_webp_1 = __importDefault(require("@images/landing/patient/oralo.webp"));
const multisettings_webp_1 = __importDefault(require("@images/landing/patient/multisettings.webp"));
const Landing_1 = require("@app/routes/Landing");
const TherapistLanding_translations_1 = require("./TherapistLanding.translations");
const RefProgramPopUp_1 = require("@app/routes/Landing/components/MainLanding/components/RefProgramPopUp");
const TherapistLanding = ({}) => {
    const language = (0, react_1.useContext)(Landing_1.LanguageContext);
    const t = TherapistLanding_translations_1.translations[language];
    const [isPopUpOpen, setIsPopUpOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement(TherapistLanding_elements_1.TherapistLandingWrap, null,
        react_1.default.createElement("h1", null, t.h1),
        react_1.default.createElement("div", { className: "landing-therapist-main-content" },
            react_1.default.createElement(TherapistLanding_elements_1.Container, { style: { color: "#7B4EF8" }, className: "landing-therapist-1" },
                react_1.default.createElement("p", null, t.mainContent["1"].p)),
            react_1.default.createElement(TherapistLanding_elements_1.Container, { className: "landing-therapist-2" },
                react_1.default.createElement("div", { className: "landing-therapist-container-images" },
                    react_1.default.createElement(two_people_svg_1.default, null),
                    react_1.default.createElement(play_button_svg_1.default, null)),
                react_1.default.createElement("div", { className: "landing-therapist-container-content" },
                    react_1.default.createElement("div", { className: "landing-therapist-container-info" },
                        react_1.default.createElement("h3", null, t.mainContent["2"].h3),
                        react_1.default.createElement("p", null, t.mainContent["2"].p)),
                    react_1.default.createElement("button", { onClick: () => setIsPopUpOpen(true) }, t.mainContent["2"].button))),
            react_1.default.createElement("div", { className: "landing-therapist-row" },
                react_1.default.createElement(TherapistLanding_elements_1.Container, { className: "landing-therapist-3" },
                    react_1.default.createElement("div", { className: "landing-therapist-container-images" },
                        react_1.default.createElement(notesboard_svg_1.default, null),
                        react_1.default.createElement(play_button_svg_1.default, null)),
                    react_1.default.createElement("div", { className: "landing-therapist-container-info" },
                        react_1.default.createElement("h3", null, t.mainContent["3"].h3),
                        react_1.default.createElement("p", null, t.mainContent["3"].p))),
                react_1.default.createElement(TherapistLanding_elements_1.Container, { className: "landing-therapist-4" },
                    react_1.default.createElement("div", { className: "landing-therapist-container-images" },
                        react_1.default.createElement(rate_svg_1.default, null),
                        react_1.default.createElement(play_button_svg_1.default, null)),
                    react_1.default.createElement("div", { className: "landing-therapist-container-info" },
                        react_1.default.createElement("h3", null, t.mainContent["4"].h3),
                        react_1.default.createElement("p", null, t.mainContent["4"].p)))),
            react_1.default.createElement("div", { className: "landing-therapist-row" },
                react_1.default.createElement(TherapistLanding_elements_1.Container, { className: "landing-therapist-5" },
                    react_1.default.createElement("div", { className: "landing-therapist-container-images" },
                        react_1.default.createElement(handlers_svg_1.default, null),
                        react_1.default.createElement(play_button_svg_1.default, null)),
                    react_1.default.createElement("div", { className: "landing-therapist-container-info" },
                        react_1.default.createElement("h3", null, t.mainContent["5"].h3),
                        react_1.default.createElement("p", null, t.mainContent["5"].p))),
                react_1.default.createElement(TherapistLanding_elements_1.Container, { className: "landing-therapist-6" },
                    react_1.default.createElement("div", { className: "landing-therapist-container-images" },
                        react_1.default.createElement(video_and_pic_svg_1.default, null)),
                    react_1.default.createElement("div", { className: "landing-therapist-container-info" },
                        react_1.default.createElement("h3", null, t.mainContent["6"].h3),
                        react_1.default.createElement("p", null, t.mainContent["6"].p))))),
        react_1.default.createElement(TherapistLanding_elements_1.Container, { className: "landing-therapist-oralo" },
            react_1.default.createElement("img", { src: oralo_webp_1.default, alt: "" }),
            react_1.default.createElement("div", { className: "landing-therapist-container-info", style: { color: "#7B4EF8" } },
                react_1.default.createElement("p", null,
                    react_1.default.createElement("strong", null, t.oralo.h4),
                    t.oralo.p))),
        react_1.default.createElement(TherapistLanding_elements_1.Container, { className: "landing-therapist-settings" },
            react_1.default.createElement("img", { src: multisettings_webp_1.default, alt: "" }),
            react_1.default.createElement("h2", null, t.settings)),
        isPopUpOpen && react_1.default.createElement(RefProgramPopUp_1.RefProgramPopUp, { onClose: () => setIsPopUpOpen(false) })));
};
exports.TherapistLanding = TherapistLanding;
